import { TRIGGER_FETCH_TXN_LIST_API, TRIGGER_FETCH_TXN_LIST_API_SUCCESS, CLEAR_TXN_LIST } from 'redux/actionTypes';

export function triggerFetchTxnListApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_FETCH_TXN_LIST_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerFetchTxnListApiCallSuccess(data, txnList) {
	return {
		type: TRIGGER_FETCH_TXN_LIST_API_SUCCESS,
		data,
		txnList,
	};
}

export function clearTxnList() {
	return {
		type: CLEAR_TXN_LIST,
	};
}
